/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Grid from "@mui/material/Unstable_Grid2";
import CatalogWithoutImg from "../Shared/CatalogList/CatalogWitoutImg";
import ProductsListView from "./ProductsListView";
import ProductsListFilters from "./ProductsListFilters";
import PaginationSection from "./PaginationSection";
import constants from "../../constants";
import { postAPIService } from "../API";
import { getProductsPayload } from "../../utils";
import { useDispatch } from "react-redux";
import { clearProductList, getProductsList } from "../../actions";
import { useLocation } from "react-router-dom";
import ProductListSkeleton from "../Skeletons/ProductListSkeleton";
import { Container } from "@mui/material";
import Footer from "../Footer";
import Categorylist from "../App/CategoryList/CategoryList";
import { ProductListFilterNew } from "./ProductsListFilters/ProductListFilterNew";
import styled from "styled-components";

const ProductsList = () => {
  const selectedFilters = useSelector(
    (state) => state?.allProducts?.filters || {}
  );

  useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  const [enablePagination, setEnablePagination] = useState(false);
  const [loading, setLoading] = useState(false);
  const [productListCount, setProductListCount] = useState(0);
  const [pageSize, setPageSize] = useState(40);
  const [offset, setOffset] = useState(0);
  const [filterLoader, setFilterLoader] = useState(false);
  const [sort,setSort]=useState('sortBy_priceLowToHigh')
  const dispatch = useDispatch();
  const location = useLocation();
  const categoryId = location?.pathname?.split("/")[2] || "";

  const query = new URLSearchParams(location.search);
  const curPage = parseInt(query.get("page") || "0");

  console.log('current page issssssssssssssssssssssss',curPage)
 
  useEffect(() => {
   
 

  }, []);


  const getProductsCall = async ({ URL, payload }) => {
    return postAPIService({ url: URL, data: payload })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error", error);
        setLoading(false);
        setFilterLoader(false);
      });
  };

  const handleApplyFilters = async () => {
    const URL = constants.Apis.getProductsList;
    setFilterLoader(true);
    const payload = getProductsPayload({
      categoryId,
      selectedFilters,
      curPage,
    });
    const productResponse = await getProductsCall({ URL, payload });
    const { productsList: { totalCount = 0 } = {} } =
      productResponse?.data || {};
    dispatch(getProductsList(productResponse.data));
    if (totalCount > 40) {
      setEnablePagination(true);
      setProductListCount(totalCount);
    }
    setFilterLoader(false);
  };

  useEffect(() => {
    const fetchProductsList = async () => {
      const URL = constants.Apis.getProductsList;
      setLoading(true);
      const payload = getProductsPayload({ categoryId, curPage,sort });
      const productResponse = await getProductsCall({ URL, payload });
      const {
        totalCount = 0,
        pageSize = 40,
        offset = curPage || 0,
        
      } = productResponse?.data || {};
      dispatch(getProductsList(productResponse.data));
      if (totalCount > 40) {
        setEnablePagination(true);
        setProductListCount(totalCount);
        setPageSize(pageSize);
        setOffset(parseInt(offset + 1));
      }
      setLoading(false);
    };

    dispatch(clearProductList());
    fetchProductsList();
  }, [categoryId,sort]);

  const updateURI = (pages) => {
    query.set("page", pages);
    window.location.href = `?${query}`;
  };


  const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 1rem;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 5rem;

  `
  const MainInnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  min-height: 80vh;


  @media (max-width: 900px) {
    flex-direction: column;
  }`



  return (
    <React.Fragment>
      
      <MainContainer>
      
          {loading ? (
            <ProductListSkeleton />
          ) : (
            <>
            
              
      
              <MainInnerContainer>
                 <ProductListFilterNew handleApplyFilters={handleApplyFilters} sort={sort} setSort={setSort} />
              
              
                {filterLoader ? <ProductListSkeleton /> : <ProductsListView />}

              </MainInnerContainer>
              


           
                {enablePagination && (
                  <PaginationSection
                    productListCount={productListCount}
                    pageSize={pageSize}
                    offset={offset}
                    updateURI={updateURI}
                  />
                )}
              
            </>
          )}
        
       </MainContainer>
      <Container
        maxWidth={"xl"}
        sx={{ p: 0, pt: 2, mt: 2, bottom: 0, position: "relative" }}
      >
       
      </Container>
      <Footer />
    </React.Fragment>
  );
};
export default ProductsList;
